var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "unsubscribe-container",
    class: {
      'loading': _vm.loading,
      'disabled': _vm.disabled,
      'unfollowed': !_vm.active
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    staticClass: "unsubscribe"
  }, [_vm._v(" " + _vm._s(_vm.buttonLabel) + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }